import { useEffect, useState } from 'react';

import { logException } from '@atlassian/conversation-assistant-instrumentation/services/sentry';

type OcgTwilioClientModule = typeof import('./ocg-twilio-client');

export const useTwilioOcgClient = (): typeof import('./ocg-twilio-client') | undefined => {
	const [ocgClient, setOcgClient] = useState<OcgTwilioClientModule | undefined>();

	useEffect(() => {
		(async () => {
			try {
				setOcgClient(
					await import(
						/* webpackChunkName: "@atlassian/conversation-assistant-widget/ocg-twilio-client" */ './ocg-twilio-client'
					),
				);
			} catch (error) {
				logException({
					exception: error,
					name: 'OcgClientImportFailed',
				});
			}
		})();
	}, []);

	return ocgClient;
};
